module.exports = __webpack_public_path__ + "static/media/Cooked_serpent_meat.c0df9d7b.png";